export const IS_SERVER = typeof window === "undefined";

export const BUILD_VERSION = process.env.NEXT_PUBLIC_BUILD_VERSION;

export const GTM_ID = process.env.GTM_ID;

export const FB_PIXEL_ID = process.env.FB_PIXEL_ID;

export const DISCORD_INVITE_URL = "https://discord.gg/VNWE8Rkf";

export const REFERRAL_CODE_STORAGE_KEY = "vidmuse_referral_code";

export const MAX_UPLOAD_FILE_COUNT = 5;
